<template>
  <div class="main">
    <section class="panel panel-default" style="margin-bottom: 0px;" v-if="isAdmin('stay') ">
      <header class="panel-heading" style="padding: 10px;">
        <div class="panel-actions" style="top: 7px;">
          <a href="#searchArea" data-toggle="collapse" class="panel-action panel-action-toggle"></a>
        </div>
        <h4 class="panel-title">查詢條件</h4>
      </header>
      <div id="searchArea" class="panel-collapse collapse">
        <div class="panel-body">
          <div class="row form-group">
            <div class="col-md-12 ">
              <div class="col-md-4">
                <label class="col-md-4">住宿類型</label>
                <div class="col-md-8">
                  <select v-model="dormitoryType" class="form-control">
                    <option value="">--請選擇--</option>
                    <option value="N">一般宿舍</option>
                    <option value="V">寒暑假宿舍</option>
                    <option value="S">特殊原因宿舍</option>
                  </select>
                </div>
              </div>
              <div class="col-md-4">
                <label class="col-md-4">學期</label>
                <div class="col-md-8">
                  <select v-model="smtr" class="form-control">
                    <option value="">--請選擇--</option>
                    <option v-for="(year, index) in selectYear()" :key="index" :value="year.value">{{ year.text }}
                    </option>
                  </select>
                </div>
              </div>
              <div class="col-md-4">
                <label class="col-md-4">學號</label>
                <div class="col-md-8">
                  <input type="text" v-model="account" class="form-control"/>
                </div>
              </div>
            </div>
          </div>
          <div class="row form-group">
            <div class="col-md-12 ">
              <div class="col-md-4">
                <label class="col-md-4">學生姓名</label>
                <div class="col-md-8">
                  <input type="text" v-model="name" class="form-control"/>
                </div>
              </div>
              <div class="col-md-4">
                <label class="col-md-4">外宿日期</label>
                <div class="col-md-8">
                  <datepicker :format="customFormatter" :language="zh" v-model="overnightDate" input-class="form-control topIndex" :style="{width:'auto', display:'inline-block'}"/>
                </div>
              </div>
            </div>
          </div>
          <div class="row form-group">
            <div class="col-md-4 "></div>
            <div class="col-md-4 ">
              <div class="col-xs-5 col-md-4">
                <button type="button" class="btn btn-default btn-block" @click="clearSearchParam()">清除</button>
              </div>
              <div class="col-xs-2 col-md-4"></div>
              <div class="col-xs-5 col-md-4">
                <button type="button" class="btn btn-danger btn-block" @click="updateGrid(1)">查詢</button>
              </div>
            </div>
            <div class="col-md-4 "></div>
          </div>
        </div>
      </div>
    </section>
    <section class="panel">
      <header class="panel-heading">
        <h2 class="panel-title">外宿請假單</h2>
      </header>
      <div class="panel-body container-fluid">
        <div class="row">
          <div class="col-md-12">
            <table class="table table-no-more table-bordered table-striped mb-none">
              <thead>
              <tr>
                <th class="text-center" width="10%">學期</th>
                <th class="text-center" width="10%">學制</th>
                <th class="text-center" width="15%">系科年級</th>
                <th class="text-center" width="10%">學號</th>
                <th class="text-center" width="10%">姓名</th>
                <th class="text-center" width="15%">宿舍床位</th>
                <th class="text-center" width="10%">待審核筆數</th>
                <th class="text-center" width="10%">請假通過次數</th>
                <th class="text-center" width="10%">請假不通過次數</th>
              </tr>
              </thead>
              <tbody>
              <tr v-for="(item, index) in overnightList" :key="index">
                <td class="text-center" data-title="學期">{{ item.smtr }}</td>
                <td class="text-center" data-title="學制">{{ item.deptSsymStr }}</td>
                <td class="text-center" data-title="系科年級">
                  {{ item.deptCodeStr }}{{ item.drade }}年{{ item.dradeClass }}班
                </td>
                <td class="text-center" data-title="學號">{{ item.account }}</td>
                <td class="text-center" data-title="姓名">
                  <a class="btn btn-link"
                     @click="gotoView('stay.overnight.detail', {account:item.account, smtr:item.smtr, dormitoryType:item.dormitoryType})">{{ item.name }}</a>
                </td>
                <td class="text-center" data-title="宿舍床位">{{ item.bedFloor }}{{ item.bedRoom }}-{{ item.bed }}</td>
                <td class="text-center" data-title="待審核筆數">{{ item.waitCount }}</td>
                <td class="text-center" data-title="請假通過次數">{{ item.succCount }}</td>
                <td class="text-center" data-title="請假不通過次數">{{ item.failCount }}</td>
              </tr>
              </tbody>
            </table>
          </div>
          <div class="col-md-12">
            <div class="text-center">
              <pageControl v-bind:page="page" v-bind:total="totalPage"></pageControl>
            </div>
          </div>
        </div>
      </div>
    </section>
  </div>
</template>
<script>
export default {
  data() {
    return {
      dormitoryType: "",
      accountType: "",
      overnightList: {},
      page: 1,
      pageSize: 10,
      totalPage: 0,
      smtr: "",
      account: "",
      applyStatus: "",
      name: "",
      overnightDate: ""
    }
  },
  methods: {
    updateGrid(page) {
      //更新Grid 必需
      this.page = page;
      this.getInitData();
    },
    getInitData() {
      const Api = async () => {
        const api = "/api/RoomOvernight/overnightMasterList";
        return await this.$axios.post(api, JSON.stringify({
          page: this.page,
          pageSize: 10,
          model: {
            smtr: this.smtr,
            dormitoryType: this.dormitoryType,
            applyStatus: this.applyStatus,
            account: this.account,
            name: this.name,
            overnightDate: this.overnightDate,
          }
        }));
      };
      Promise.resolve(Api()).then(resp => {
        this.overnightList = resp.data.data.rows;
        this.totalPage = resp.data.data.total
        this.page = resp.data.data.page;
      });
    },
    selectYear() {
      let smtrArray = [];
      if (!this.dormitoryType) {
        return smtrArray;
      }
      for (let y = parseInt(this.applySmtr.substring(0, 3)); y > 107; y--) {
        if (this.dormitoryType == "N") {
          smtrArray.push({text: y + "年第二學期", value: y + "2"});
          smtrArray.push({text: y + "年第一學期", value: y + "1"});
        } else {
          smtrArray.push({text: y + "年", value: `${y}`});
        }
      }
      return smtrArray;
    },
    clearSearchParam() {
      this.smtr = ""
      this.dormitoryType = ""
      this.account = ""
      this.name = "";
      this.overnightDate = "";
    }
  },
  mounted() {
    if (this.isAdmin('stay')) {
      //套用查詢設定
      const storeQryParam = JSON.parse(this.getStore(`${this.$route.name}.qryParam`));
      if (storeQryParam != null) {
        this.dormitoryType = storeQryParam.dormitoryType;
        this.smtr = storeQryParam.smtr;
        this.account = storeQryParam.account;
        this.name = storeQryParam.name;
        this.overnightDate = storeQryParam.overnightDate;
      }

      const storePage = this.getStore(`${this.$route.name}.page`);
      if (storePage != null) {
        this.page = storePage;
      }

      this.getInitData();
    } else {
      this.gotoView("stay.overnight.detail", {account: this.sessionData.account});
    }
  },
  beforeRouteLeave(to, from, next) {
    //保留查詢設定
    if (to.name.startsWith("stay.overnight.")) {
      this.setStore(`${this.$route.name}.qryParam`, {
        dormitoryType: this.dormitoryType,
        smtr: this.smtr,
        account: this.account,
        name: this.name,
        overnightDate: this.overnightDate,
      });
      this.setStore(`${this.$route.name}.page`, this.page);
    } else {
      this.removeStore(`${this.$route.name}.page`);
      this.removeStore(`${this.$route.name}.qryParam`);
    }
    this.removeStore(this.$route.name);
    next();
  }
}
</script>
